/**
 * True for the SaaS platform's own operator staff (digicampusbd's real
 * `ROLE_DEV_SUPPORT` role — see backend `AccessService.isPlatformOperator`
 * javadoc for the audit that distinguished this from a single institute's
 * own `user.superAdmin`). Institute-scoped admin screens (Users, Roles,
 * Permissions, Class Configuration, the ZK Devices/SMS Balance pages
 * themselves) should keep gating on `user.superAdmin` — only the genuinely
 * cross-tenant capabilities within them (an arbitrary "Institute ID" field,
 * an "All Institutes" tab/list) should gate on this instead.
 */
export function isPlatformOperator(user) {
  return !!(user && user.roleName === "ROLE_DEV_SUPPORT");
}
